import { SCUIGeneralModal } from '@/atomic/molecules/SCUIGeneralModal/SCUIGeneralModal';
import { SCUIButton } from '@/atomic/atoms';
import { SCUICustomDataGrid } from '@/atomic/molecules/SCUICustomDataGrid/SCUICustomDataGrid';
import { Box, CircularProgress, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { GrowManagementQuery } from '@/services/query';
import Swal from 'sweetalert2';
import { GROW } from '../growManagement.classes';

export const GrowLogModal = ({
    open,
    onClose,
    warehouseCode,
}: {
    open: boolean;
    onClose: () => void;
    warehouseCode: string;
}) => {
    const { t } = useTranslation();
    const [logs, setLogs] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(0);

    const columns = [
        {
            field: 'message',
            headerName: t('growManagement.operationType'),
            flex: 2,
            renderCell: (params: any) => (
                <Tooltip title={params.value || ''} arrow>
                    <span
                        className={GROW.logDatagridCellMessage}
                        style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    >
                        {params.value}
                    </span>
                </Tooltip>
            ),
        },
        {
            field: 'createdTime',
            headerName: t('growManagement.date'),
            flex: 0.8,
            valueGetter: (params: any) => {
                if (!params) return '';
                const d = new Date(params);
                return d.toLocaleDateString();
            },
        },
        {
            field: 'time',
            headerName: t('growManagement.time'),
            flex: 0.6,
            valueGetter: (_value: any, row: any) => {
                if (!row?.createdTime) return '';
                const d = new Date(row.createdTime);
                return d.toLocaleTimeString();
            },
        },
        { field: 'userName', headerName: t('growManagement.user'), flex: 1 },
    ];

    useEffect(() => {
        if (open && warehouseCode) {
            setIsLoading(true);
            setPageNumber(0);
            GrowManagementQuery.GetGrowOpsLogs({ warehouseCode })
                .then((res: any) => {
                    const data = (res || []).map((item: any, index: number) => ({ ...item, id: index }));
                    setLogs(data);
                    setIsLoading(false);
                })
                .catch(() => {
                    Swal.fire(t('growManagement.serverError'), t('general.error'), 'error');
                    setIsLoading(false);
                });
        }
    }, [open, warehouseCode]);

    return (
        <SCUIGeneralModal
            sx={{
                '.MuiDialogTitle-root': {
                    fontSize: '16px !important',
                    fontWeight: 'bold',
                },
            }}
            open={open}
            onClose={onClose}
            width={'lg'}
            title={`${t('growManagement.logModalTitle')} - ${warehouseCode}`}
        >
            <Box className={GROW.logModalBody} sx={{ padding: '0 24px 24px 24px', minHeight: '300px' }}>
                {isLoading ? (
                    <Box className={GROW.logModalLoading} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box className={GROW.logModalGridWrap}>
                        <SCUICustomDataGrid
                            rows={logs}
                            columns={columns}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageSizeChange={(size: number) => {
                                setPageSize(size);
                                setPageNumber(0);
                            }}
                            onPageChange={(page: number) => setPageNumber(page)}
                        />
                    </Box>
                )}
                <Box className={GROW.logModalFooter} sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
                    <SCUIButton
                        className={GROW.inputButtonLogClose}
                        type="secondary"
                        text={t('general.close')}
                        onClick={onClose}
                        sizeType="default"
                        size="s"
                    />
                </Box>
            </Box>
        </SCUIGeneralModal>
    );
};
